<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="50">

    <app-push-notification-reminder-types
      [pushNotificationTemplates]="pushNotificationTemplates"
      [reminderType]="ePushNotificationReminderType.AnnualFee"
      [caption]="'Annual Fee push notification reminders'"
      description='Use negative values down to -14 to send the reminder BEFORE the due date. Do not use duplicate values for "Order". Day offsets are based on the previous reminder and may not be negative, except the first one. Day offsets must be integers and there can only be one reminder per day.'
    >
    </app-push-notification-reminder-types>

    <app-push-notification-reminder-types
      [pushNotificationTemplates]="pushNotificationTemplates"
      [reminderType]="ePushNotificationReminderType.Onboarding"
      [caption]="'Onboarding push notification reminders'"
      description='Use for reminders for devices that have started but not finished their order. Do not use duplicate values for "Order". Day offsets are based on the previous reminder and must be greater or equal 1. There can only be one reminder per day. Caution, some template values might not be known.'
    >
    </app-push-notification-reminder-types>

    <app-email-reminder-types
      [emailTemplates]="orderEmailTemplates"
      [invoiceType]="invoiceType.Individual"
      [reminderType]="reminderType.Order"
      [caption]="'Order email reminders'">
    </app-email-reminder-types>
    <app-email-reminder-types
      [emailTemplates]="orderEmailTemplates"
      [invoiceType]="invoiceType.Bulk"
      [reminderType]="reminderType.Order"
      [caption]="'Bulk orders email reminders'">
    </app-email-reminder-types>
    <app-email-reminder-types
      [emailTemplates]="invoiceEmailTemplates"
      [invoiceType]="invoiceType.AnnualFee"
      [reminderType]="reminderType.Invoice"
      [caption]="'Annual fee email reminders'">
    </app-email-reminder-types>
    <app-email-reminder-types
      [emailTemplates]="invoiceEmailTemplates"
      [invoiceType]="invoiceType.OrderCancellation"
      [reminderType]="reminderType.Invoice"
      [caption]="'Cancellation email reminders'">
    </app-email-reminder-types>
    <app-debtor-service-config></app-debtor-service-config>
    <app-user-config></app-user-config>
    <app-invoices-configs></app-invoices-configs>
    <app-invoices-paid-configs></app-invoices-paid-configs>
  </div>
  <div fxFlex="50">
    <app-email-config></app-email-config>
    <app-fee-service-config></app-fee-service-config>

    <app-push-notification-customer-configs></app-push-notification-customer-configs>
    <app-push-notification-load-configs></app-push-notification-load-configs>

    <app-customer-config></app-customer-config>
    <app-order-config></app-order-config>
    <app-total-card-order-config></app-total-card-order-config>
    <app-web-id-config></app-web-id-config>
  </div>
</div>
